var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{style:({
    'padding-top': _vm.paddingTop + 'px',
    'padding-bottom': _vm.paddingBottom + 'px',
    'background-color': _vm.useBackgroundColor
  })},[_c('div',{class:{ 'container': _vm.useContainer, 'redirect-block-select': _vm.blockParams?.isUrl },on:{"click":function($event){return _vm.$emit('block:redirect')}}},[_c('div',{staticClass:"columns columns--cards"},_vm._l((_vm.blocksByTag),function(block,index){return _c('div',{key:index,staticClass:"column col-6 sm-col-12"},[_c('bg-img-btn-block',{staticStyle:{"height":"100%"},attrs:{"fields":_vm.convertBlockFields(block),"image-limit":_vm.imageLimit}})],1)}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }